import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { RentalObjectCategory } from '../../model/const/enums';
import { CreateContractCommandHandler } from '../../service/command/create-contract-command-handler.service';
import { VacantCommandHandlerResolver } from '../../service/command/vacant-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { VacantRentalObjectService } from '../../service/data/vacant-period.service';
import { VacantRentalObjectComponentBase } from '../base/vacant-rental-object.base';

@Component({
    selector: 'app-vacant-parking',
    templateUrl: './vacant-parking.component.html',
    styleUrls: ['./vacant-parking.component.scss'],
    providers: [CreateContractCommandHandler, VacantCommandHandlerResolver, { provide: 'category', useValue: RentalObjectCategory.Parking }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacantParkingComponent extends VacantRentalObjectComponentBase {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    messageService: MessageService,
    navigation: NavigationService,
    service: VacantRentalObjectService,
    dispatcher: CommandDispatcher,
    handlerResolver: VacantCommandHandlerResolver
  ) {
    super(columnDefinitionService, messageService, navigation, service, dispatcher, handlerResolver);
  }

  protected get category(): RentalObjectCategory {
    return RentalObjectCategory.Parking;
  }

  onRowClicked(e: { context: any; event: any }): void {
    this.navigation.navigate(['vacantparking', 'edit', e.context.rentalObjectId], null, e.event.ctrlKey);
  }
}
